module.exports = __webpack_public_path__ + "static/logo-c3a2198156eb54f6f9e23253dabd064f.png";